module.exports = __webpack_public_path__ + "img/lineup-hero2.75912099.svg";